import { trackRetryPaymentClick } from './PaymentState.tracking';

export default [
  'cardPaymentService',
  '$scope',
  'placingTermsApi',
  function (cardPaymentService, $scope, placingTermsApi) {
    $scope.getState = cardPaymentService.getState;

    $scope.handleRetryClick = () => {
      const sum = cardPaymentService.getPaymentSum();

      trackRetryPaymentClick(sum);

      placingTermsApi.showRefillAccountPopup('balance', sum);
    };
  },
];
